module.exports = __webpack_public_path__ + "media/images/b2b_admin/search-lines-07666a93b6581c1727721b59c8063863.svg";